import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import HeadingLayout from '@/components/elements/Heading';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface ProcessProps {
  blok: any;
  content: any;
}

const Process: FC<ProcessProps> = ({ blok }) => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.35,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <Section {...storyblokEditable(blok)}>
      <Container
        size={'wider'}
        className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16 lg:gap-24"
      >
        <div className="top-16 self-start md:sticky">
          <StandardText blok={blok} size={StandardTextSize.MD} />
        </div>
        <motion.ol
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className="ml-20 list-outside list-none md:ml-8"
        >
          {blok.steps.map((v, i) => (
            <motion.li variants={item} key={v._uid}>
              <div className="[:nth-child(0)]:tracking-[4px] grid h-12 w-12 -translate-x-[calc(100%+1.5rem)] translate-y-[3rem] place-content-center items-center rounded-full bg-theme-primary p-1 text-center text-4xl font-extralight text-white">
                <span className="-mb-1">{i + 1}</span>
              </div>
              <HeadingLayout size="2xs" weight="medium" className="my-2">
                {v.headline}
              </HeadingLayout>
              <Prose content={v.description} size="sm" />
            </motion.li>
          ))}
        </motion.ol>
      </Container>
    </Section>
  );
};

export default Process;
